import React from 'react';

const BS_GridBasic = () => {
    return (
        <div>
            <h1>BS_GridBasic Component</h1>
            <p>Content coming soon...</p>
        </div>
    );
}

export default BS_GridBasic;
